import { combineReducers } from 'redux';
import userReducer from 'reducers/user';
import serieReducer from 'reducers/serie';
import questionReducer from 'reducers/question';
import resultReducer from 'reducers/result';

export default combineReducers({
  user: userReducer,
  serie: serieReducer,
  question: questionReducer,
  result: resultReducer
});